
import { create_thread_fail, delete_thread_fail, delete_thread_sucsess, fetch_thread_list_failed, fetch_thread_list_start_loading, fetch_thread_list_success, set_params_list, set_workflow_category, set_workflow_category_by_group, set_workflow_list, set_workflow_listing_loader, set_workflow_loader, set_workflow_node_list } from "./reducer";
import { build_work_flow, clear_context, create_new_thread, create_work_flow, delete_Thread, delete_thread_bulk, edit_Thread_title, get_Threads, node_list, remove_workflow, workflow_category_list, workflow_list } from "../../helpers/fakebackend_helper";
import { open_success_modal } from "../Success_Modal/reducer";
import { cond, uniqueId } from "lodash";
import { Bot_Chat_History_mongo } from "../thunks";
import config from "../../config";
import { open_error_modal } from "../Error_Modal/reducer";





export const FETCH_WORKFLOW_NODE_LIST = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(set_workflow_loader(true))
    
 
      response = node_list();
    
    
    var data = await response;

     if(data){
       dispatch(set_workflow_node_list(data))
     }


      

     dispatch(set_workflow_loader(false))

   
    
  } catch (error) {
    console.log("Error While Fetching Workflow Node list",error);
    
    dispatch(set_workflow_loader(false))
  }
};


export const CREATE_WORKFLOW = (filterData) => async (dispatch) => {



    try {
      let response;
  
     
  
  
  
      dispatch(set_workflow_loader(true))
      
   
        response = build_work_flow(filterData);
      
      
      var data = await response;

  
       dispatch(set_workflow_loader(false))
      //  console.log(data.workflow_result.execution_trace)
       const execution_trace = data.workflow_result.execution_trace
       const last_second_index = execution_trace.length -2
       const final_result = execution_trace[last_second_index].output_to_next_node
        dispatch(open_success_modal(` Work Flow Build Successfully Final Result :  ${final_result} `))
     
      
    } catch (error) {
      console.log("Error While Workflow Building",error);
      
      dispatch(set_workflow_loader(false))
    }
  };



  
export const FETCH_WORKFLOW_LIST = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(set_workflow_listing_loader(true))
    
 
      response = workflow_list(filterData);
    
    
    var data = await response;

     if(data){
       dispatch(set_workflow_list(data))
     }


      

     dispatch(set_workflow_listing_loader(false))

   
    
  } catch (error) {
    console.log("Error While Fetching Workflow  list",error);
    
    dispatch(set_workflow_listing_loader(false))
  }
};




  
export const FETCH_WORKFLOW_CATEGORY_LIST = (filterData) => async (dispatch) => {



  try {
    let response;





    // dispatch(set_workflow_listing_loader(true))
    
 
      response = workflow_category_list(filterData);
    
    
    var data = await response;

     if(data){
       dispatch(set_workflow_category(data))
     }


      

    //  dispatch(set_workflow_listing_loader(false))

   
    
  } catch (error) {
    console.log("Error While Fetching Workflow  category  list",error);
    
    // dispatch(set_workflow_listing_loader(false))
  }
};


export const FETCH_WORKFLOW_CATEGORY_LIST_BY_GROUP_ID = (filterData) => async (dispatch) => {



  try {
    let response;





    // dispatch(set_workflow_listing_loader(true))
    
 
      response = workflow_category_list(filterData);
    
    
    var data = await response;

     if(data){
       dispatch(set_workflow_category_by_group(data))
     }


      

    //  dispatch(set_workflow_listing_loader(false))

   
    
  } catch (error) {
    console.log("Error While Fetching Workflow  category  list by group ID",error);
    
    // dispatch(set_workflow_listing_loader(false))
  }
};




export const CREATE_WORKFLOW_BLANK = (filterData,navigate) => async (dispatch) => {



    try {
      let response;
  
     
  
  
  
      dispatch(set_workflow_listing_loader(true))
      
   
        response = create_work_flow(filterData);
      
      
      var data = await response;

  
       dispatch(set_workflow_listing_loader(false))
       navigate("/workflow", {
        state:{
           Workflow_ID : data.workflow.Workflow_ID
        }
       })
      
    } catch (error) {
      console.log("Error While creating Workflow .",error);
      dispatch(open_error_modal("Something Went Wrong While Creating Workflow"))
      dispatch(set_workflow_listing_loader(false))
    }
  };




export const DELETE_WORKFLOW = (filterData) => async (dispatch) => {



    try {
      let response;
  
     
  
  
  
      dispatch(set_workflow_loader(true))
      
   
        response = remove_workflow(filterData);
      
      
      var data = await response;

  
       dispatch(set_workflow_loader(false))
        dispatch(open_success_modal(` Work Flow Deleted Successfully `))
        dispatch(FETCH_WORKFLOW_LIST())
      
    } catch (error) {
      console.log("Error While Deleting Workflow",error);
      
      dispatch(set_workflow_loader(false))
    }
  };

  
  




  




  


  

